/**
 * @imports
 */
import React, { useState } from 'react'
import { Button, Popconfirm, Tooltip } from 'antd'
import Api from '../../../Api'
import Exception from '../../../Exception'

function fnComValidarPdaServ(pda) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await Api.post('/kernel/mutator', {
        model: 'ComOrdenService',
        id: pda.iId,
        values: { iIdUsuarioValida: Api.getUserId(), }
      })

      if (!res.data.ok) {
        throw new Error(res.data.error)
      }

      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

/**
 *
 * @param {*} props
 * @returns
 */
export function ComValidarSuministroEquipo(props) {
  const [loading, setLoading] = useState(false)
  const { pda } = props

  const handleClick = () => {
    setLoading(true)
    fnComValidarPdaServ(pda)
      .then(() => {
        props.onValidado && props.onValidado()
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
        Exception.load(err).show()
      })
  }

  return (
    <Popconfirm
      title={<span>
        <span>Al validar el suministro para la partida de la OS, <b>acepta que el equipo/unidad ha sido entregada</b></span><br/>
        <span>esta opción iniciará el tiempo para el primer periodo <b> a partir de este momento</b>, ¿Desea continuar?</span>
      </span>}
      okText='Si'
      cancelText='No'
      onConfirm={handleClick}
      children={
        <Tooltip title='Iniciar ingreso de unidad o equipo'>
          <Button
            loading={loading}
            type="ghost"
            icon='check'
            size='small'
          />
        </Tooltip>
      }
    />
  )
}
